<template>
  <section class="classManagementPage">
    <g-breadcrumb bread="班级管理" />
    <SearchForm>
      <el-form ref="ref_searchForm" :inline="true" :model="searchForm" label-width="80px">
        <el-form-item>
          <el-cascader
            v-model="searchForm.kindergartenIds"
            style="width: 420px;"
            :options="orgGardenTree"
            placeholder="请选择归属"
            clearable
            filterable
            collapse-tags
            :props="{ multiple: true, checkStrictly: false, emitPath: false, label: 'orgName', value: 'orgId' }"
          />
        </el-form-item>
        <el-form-item>
          <el-select v-model="searchForm.gradeCode" placeholder="请选择年级" clearable>
            <el-option
              v-for="item in gradeOptions"
              :key="item.dicCode"
              :label="item.dicName"
              :value="item.dicCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchData">搜 索</el-button>
        </el-form-item>
      </el-form>
    </SearchForm>
    <TableContainer title="班级列表">
      <template slot="button">
        <el-button type="warning" class="add-button" @click="addEventCenter">年级月龄管理</el-button>
      </template>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="groupCompanyName" label="所属集团" min-width="100" />
        <el-table-column prop="areaName" label="所属片区" min-width="100" />
        <el-table-column prop="kindergartenName" label="所属园所" min-width="100" />
        <el-table-column prop="classCode" label="班级编号" min-width="100" />
        <el-table-column prop="gradeName" label="年级" min-width="100" />
        <el-table-column prop="className" label="班级" min-width="100" />
        <el-table-column prop="teacherName" label="讲师" min-width="100" />
        <el-table-column prop="studentCount" label="学生数" min-width="100" />
        <el-table-column width="120" label="操作">
          <template slot-scope="scope">
            <el-button type="text" class="textOrange" @click="deleteClass(scope.row)">移除班级</el-button>
          </template>
        </el-table-column>
      </el-table>
      <GPagination v-show="total > 0" ref="ref_GPagination" :total="total" :page.sync="searchForm.page" :size.sync="searchForm.size" @pagination="fetchData" />
    </TableContainer>

    <GDialog :dialog.sync="gradeAgeMonthDialog" @btnSure="submitFormGradeAgeMonth('gradeAgeMonthRef')">
      <ageMonthPage ref="gradeAgeMonthRef" :grade-age-month-form.sync="gradeAgeMonthForm" :timestamp="timestamp" />
    </GDialog>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import ageMonthPage from './ageMonthPage.vue'
import { selectClassInfoList, deleteClassInfo,updateGradeAgeMonth } from '@api/classManagement/api_classManagement'
import { getDictoryInfoByCode } from '@api/api_common'
export default {
  components: {
    ageMonthPage
  },
  data() {
    return {
      gradeAgeMonthDialog: {
        title: '标题',
        visible: false
      },
      currentRow: {},
      gradeOptions: [],
      tableData: [],
      total: 0,
      timestamp:0,
      searchForm: {
        kindergartenIds: [],
        gradeCode: '',
        page: 1,
        size: 20
      },
      gradeAgeMonthForm:{
        id:'',
        gradeCode:'',
        minBabyAge:'',
        minBabyMonth:'',
        maxBabyAge:'',
        maxBabyMonth:''
      }
    }
  },
  computed: {
    ...mapState('commonModule', ['orgGardenTree'])
  },
  created () {
    getDictoryInfoByCode('GRADE_TYPE').then(res => { this.gradeOptions = res })
    this.getOptions()
    this.fetchData()
  },

  methods: {
    getOptions () {
      // 查询组织机构树-到片区；2到片区，3到园所
      this.$store.dispatch('commonModule/getOrgTree', 3)
    },
    fetchData() {
      selectClassInfoList(this.searchForm).then(res => {
        this.tableData = res.records
        this.total = res.total
      })
    },
    deleteClass (row) {
      this.$confirm('是否确认删除?', '提示', {
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        if (parseInt(row.studentCount) > 0) {
          this.$message.error('该班级下有学生，不可移除！')
          return false
        }
        deleteClassInfo({ classId: row.classId }).then(res => {
          this.$message.success('移除班级成功！')
          if (this.total % this.searchForm.size === 1) {
            this.searchForm.page = this.searchForm.page - 1 === 0 ? 1 : this.searchForm.page - 1
          }
          this.$refs.ref_GPagination.resetDeletPage()
        })
      })
    },
    addEventCenter(){
      this.gradeAgeMonthDialog.visible = true
      this.gradeAgeMonthDialog.title = '编辑月龄'
    },
    submitFormGradeAgeMonth(formName){
      const ref = this.$refs[formName].$refs.ref_gradeAgeMonthForm
      ref.validate(valid => {
        if (!valid) { return false }
        updateGradeAgeMonth(this.gradeAgeMonthForm).then(res => {
          this.$message.success('年级更新成功！')
          this.gradeAgeMonthDialog.visible = false
          this.$refs.ref_GPagination.resetDeletPage()
        })
      })
    }
  }
}
</script>

<style lang="scss"></style>
